import axios from "axios";
import React, { useState, useEffect, useRef } from "react";
import Option from "./Option";

const OptionView = ({ db_elm_id, elm, title, ratio, login_count, session_id, session_sts, baseURL, vote_status }) => {
  const ref = useRef(null);
  const [expanderMX,setExpanderMW] = useState(ref);
  const currentVoteCount = ratio;

  const ratio_converter = (val) => {
    if(parseFloat(val)!==0) {
      let cur_rt =  parseInt(parseFloat(val)*100/parseFloat(login_count));
      
      cur_rt = (typeof(cur_rt)==='number') ? cur_rt : 0

      return [
        cur_rt,
        parseInt((parseFloat(expanderMX)*cur_rt)/parseFloat(expanderMX))
      ];
    } else {
      return [0,0];
    }
  }

  const setVote = (evt) => {
    let newVoteCount = (parseInt(currentVoteCount)+1);
    let voting = ((ratio_converter(newVoteCount)[1]>=100)) ? "over" : "ongoing";
    let status = (
        (!(localStorage.getItem("pp-prj-vote")!==null) && (localStorage.getItem("pp-prj-vote"))) ||
        (!(evt.currentTarget.classList.contains("active") || evt.currentTarget.classList.contains("disabled")) && 
        !(localStorage.getItem("pp-prj-vote-completion")!==null && localStorage.getItem("pp-prj-vote-completion")==="over"))
      )

    if(status) {
      setTimeout(() => {
        console.log("vote recorded!");
        axios.put(`${baseURL}/vincrease`, {newVoteCount,db_elm_id,session_id})
        .then(res => {

          console.log("vote recieved! :",res.status);
          
          localStorage.setItem("pp-prj-vote",true);
          localStorage.setItem("pp-prj-vote-completion",voting);
          localStorage.setItem("pp-prj-vote-for",db_elm_id);
          document.querySelectorAll(".result_component").forEach(rc=> rc.classList.add("disabled"));

          if(voting==="over") {
            
            axios.put(`${baseURL}/vdone`, {voting,session_id})
            .then(res => {
              console.log("voting is over! :",res.status);
            }).catch(err => console.log(`[VoteOver${err.name}]: ${err.code} [Status]: ${err.request.status}`));
          }
          vote_status[1](true);
        }).catch(err => console.log(`[VoteDiscard${err.name}]: ${err.code} [Status]: ${err.request.status}`));
      }, 100);
    } else {
      console.log("SERVER_ERR: vote discarded!");
    }
  }
 
  useEffect(() => {
    setExpanderMW(ref.current.clientWidth);
  }, []);

  let upvote = ratio_converter(currentVoteCount);
  
  if(upvote[1]>=100) { 
    localStorage.setItem("pp-prj-vote-completion","over");
    
    setTimeout(() => { 
      document.querySelector(".indicator").innerHTML = "Voting is over!";
    }, 2500);
  }

  let vote_over = (localStorage.getItem("pp-prj-vote-completion")!==null && localStorage.getItem("pp-prj-vote-completion")==="over") ? 
    ((upvote[1]>=100) ? " pop" : " disabled") : (upvote[1]>=100) ? " pop" : '';
  let same_db_elm = (localStorage.getItem("pp-prj-vote")!==null && parseInt(localStorage.getItem("pp-prj-vote-for"))===db_elm_id) ? " active" : vote_over;
  let is_disabled = (same_db_elm===" active") ? '' : ((session_sts) ? ((localStorage.getItem("pp-prj-vote")!==null) ? " disabled" : '') : '');
  let opt_clsn = `result_component${same_db_elm}${is_disabled}`;

  return (
    <Option
      clsn={opt_clsn}
      on_click_func={(e) => setVote(e)}
      opt_name={parseInt(elm).toLocaleString()+". "+title}
      key_cls={parseInt(elm).toLocaleString()}
      start_rt_ref={upvote[0]+'%'}
      expander_width={upvote[1]+'%'}
      prc_rt_ref={ref}
    />
  );
}

export default OptionView;